import { Text } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../../i18n/i18n';

export const EmploymentSummaryLine = ({ employmentCount }: { employmentCount: number }) => {
  const { t } = useTypedTranslation();
  return (
    <>
      <Text style={{ fontSize: '18px' }} fontWeight="semibold">
        {t('modal.reportReceipt.employmentSummaryLine1')}
      </Text>
      <Text>{t('modal.reportReceipt.employmentSummaryLine2', { totalRowsCount: employmentCount })}</Text>
    </>
  );
};
